import ApolloClient from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import fetch from 'node-fetch'

const STRAPI_GRAPHQL_URL = `${process.env.REACT_APP_BABYNAME_API_URL}`

const httpLink = createHttpLink({
  uri: STRAPI_GRAPHQL_URL,
  fetch: fetch,
})

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache({
    dataIdFromObject: obj =>
      !!obj.sex && !!obj.name ? `${obj.__typename}:${obj.sex}-${obj.name}` : null,
  }),
})

export default client
